var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"perzeption-demo",attrs:{"id":"demo"}},[_c(_vm.currentComponent(),{tag:"component",on:{"back":function($event){return _vm.prevStep()},"update":function($event){return _vm.nextStep()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }